import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplyForJobComponent } from './apply-for-job.component';
import { HeaderPartialModule } from '../shared/components/header-partial/header-partial.module';

@NgModule({
  declarations: [ApplyForJobComponent],
  imports: [CommonModule, HeaderPartialModule],
  exports: [ApplyForJobComponent],
})
export class ApplyForJobModule {}
